<template>
  <div class="animated fadeIn">
    <h3>EDI</h3>
    <b-row>
      <b-col cols="10">
        <b-card>
          <b-card-body>
            <b-row>
              <b-col cols="3">
                <b-form-input v-model="boxFilter" placeholder="Sök..." ref="bfilter"></b-form-input>
              </b-col>
              <b-col>

                <b-button @click="GetData()">Uppdatera</b-button>
              </b-col>
            </b-row>


            <table>
              <thead>
                <th>Namn</th>
                <th>{{ GetDirName('root') }} ({{ GetTotals().filesCount }})</th>
                <th>{{ GetDirName('failed') }} ({{ GetTotals().failedCount }})</th>
                <th>{{ GetDirName('handled') }} ({{ GetTotals().handledCount }})</th>
                <th>Typ</th>
                <th>Kommando</th>
              </thead>
              <tbody v-for="(b, i) in GetBoxes(boxFilter)" :key="i">
                <tr>
                  <td>{{ b.name }}</td>
                  <td @click="getBoxContent(b.id, 'root')">{{ b.filesCount }}</td>
                  <td @click="getBoxContent(b.id, 'failed')">
                    {{ b.failedCount }}
                  </td>
                  <td @click="getBoxContent(b.id, 'handled')">
                    {{ b.handledCount }}
                  </td>
                  <td>{{ b.type }}</td>
                  <td>{{ b.cmd }}</td>
                </tr>
                <tr v-if="b.content">
                  <td colspan="6">
                    <b-card>
                      <b-card-header>
                        <b>{{ GetDirName(b.content.dir) }}</b><br />
                        <b-row>
                          <b-col cols="2">Antal: {{ b.content.files.length }}</b-col>
                          <b-col cols="2" style="display: inline-block">Max:<input id="input-sm" style="width:30px"
                              v-model="maxCnt" /></b-col>
                          <b-col cols="4"><input autofocus type="text" v-model="b.content.filter" class="form-control"
                              placeholder="Sök i filer" /></b-col>
                          <b-col cols="1"><b-button @click="
                            getBoxContent(
                              b.id,
                              b.content.dir,
                              b.content.filter
                            )
                            ">Sök</b-button>&nbsp;<b-button v-if="b.content.dir == 'failed'"
                              @click="resendFailed(b.id)">Skicka&nbsp;om</b-button></b-col>
                          <b-col cols="2">
                            <b-button @click="downloadAllFiles(b)"
                              variant="light" size="sm"
                              title="Ladda ned alla filer"><b-icon-download></b-icon-download></b-button>
                          </b-col>
                        </b-row>
                      </b-card-header>
                      <b-card-body>
                        <b-table :items="b.content.files" :sortable="true" :fields="filefields" :small="true"><template
                            v-slot:cell(Name)="row">
                            <b-icon-file-code @click="
                              getFileContent(
                                b.id,
                                b.content.dir,
                                row.item.Name,
                                b.content.filter
                              )
                              "></b-icon-file-code>{{ row.item.Name }}
                          </template>
                        </b-table>
                      </b-card-body>
                    </b-card>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="Filinnehåll" v-model="showFileContent" v-if="currfile" size="xl">
      <div class="scroll">
        <b-card>
          <b-row>
            <b-col cols="6">
              <b>{{ currfile.filename }}</b>
            </b-col>
            <b-col cols="2">
              {{ currfile.date }}
            </b-col>
            <b-col cols="2"> {{ currfile.size }} bytes </b-col>
            <b-col>
              {{ currfile.type }}
            </b-col>
            <b-col>
              <b-button @click="downloadFileContent(currfile.id, currfile.dir, currfile.filename)" variant="light"
                size="sm" title="Ladda ned fil"><b-icon-download></b-icon-download></b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <pre>{{ currfile.content }}</pre>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();
const dirNames = { root: 'Att processa', failed: 'Misslyckade', handled: 'Hanterade' };

export default {
  name: "edilist",
  data() {
    return {
      inboxStatuses: [],
      currfile: null,
      showFileContent: false,
      boxFilter: null,
      filefields: [
        { key: 'Name', sortable: true },
        { key: 'Size', sortable: true },
        { key: 'Date', sortable: true },
      ],
      maxCnt: 50,
    };
  },
  created() {
    this.GetData();
    setTimeout(() => {
      this.$refs.bfilter.focus();
    }, 500);
  },
  methods: {
    GetData() {
      api.get("/api/edi/GetFileInboxes?InboxName=&ClientId=").then((res) => {
        //alert("OK");
        this.inboxStatuses = res.data;
        this.currfile = null;
      });
    },
    GetBoxes(f) {
      if (!f)
        return this.inboxStatuses;

      let sf = f.toLowerCase();
      return this.inboxStatuses.filter(x => JSON.stringify(x).toLowerCase().indexOf(sf) >= 0);
    },
    GetTotals() {
      var tots = { filesCount: 0, failedCount: 0, handledCount: 0 };
      this.inboxStatuses.map((x) => {
        tots.filesCount += x.filesCount;
        tots.failedCount += x.failedCount;
        tots.handledCount += x.handledCount;
      });

      return tots;
    },
    getBoxContent(id, dir, filter) {
      if (!filter) filter = "";

      var p = api.params({ id: id, dir: dir, filter: filter, maxcount: this.maxCnt });
      api.get("/api/edi/GetBoxContent?" + p).then((res) => {
        var result = res.data;
        for (var i = 0; i < this.inboxStatuses.length; i++)
          if (this.inboxStatuses[i].id === result.inboxId)
            this.inboxStatuses[i].content = result;
        this.$forceUpdate();
      });
    },
    getFileContent(id, dir, fname) {
      var p = api.params({ id: id, dir: dir, file: fname });
      api.get("/api/edi/GetFileContent?" + p).then((result) => {
        var res = result.data;
        console.log(res);

        if (res.type === "EDIFACT")
          res.content = res.content.split("UNH+").join("\nUNH+");

        //if (searchFor && searchFor !== '')
        //    res.content = res.content.split(searchFor).join('</pre><strong style="color: red;">' + searchFor + '</strong><pre>');

        this.currfile = res;
        this.showFileContent = true;
        // $("#fileContent").css("position", "absolute");
        // $("#fileContent").css("top", ($(window).height() * 0.2 + $(window).scrollTop()) + "px");
        // $("#fileContent").css("left", "20%");
        // $("#fileContent").css("border", "1px solid #CCC");
        // $("#fileContent").css("background-color", "#EEE");
        // $("#fileContent").show();

        //$scope.$apply();
      });
    },
    downloadFileContent(id, dir, filename) {
      var p = api.params({ id: id, dir: dir, file: filename });
      api.download('/api/edi/DownloadFileContent?' + p).then((res) => {
        this.isBusy = false;
      });
      //window.open(api.getFullUrl('/edi/DownloadFileContent?' + p));        
    },
    downloadAllFiles(b) {
      var files = b.content.files;
      if(files.length > 0 && confirm(`Vill du ladda ned alla ${files.length} filer?`)) {
        files.map(currfile => {
          this.downloadFileContent(b.id, b.content.dir, currfile.Name);
        })        
      }      
    }
    ,
    resendFailed(inboxId) {
      if (confirm("Vill du verkligen skicka om alla filer?")) {
        api.post('/api/edi/ResendFailed?id=' + inboxId).then((result) => {
          var res = result.data.join('\n');
          alert(res);

          this.GetData();
        });
      }
    },
    GetDirName(dir) {
      return dirNames[dir.toLowerCase()];
    }
  },
};
</script>
<style>
td {
  vertical-align: middle;
  border: 1px solid darkgray;
}

th {
  vertical-align: middle;
  border: 1px solid darkgray;
}

.scroll {
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>